import React, { useMemo } from 'react';
import {
  Button,
  Stack,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import EventNoteIcon from '@mui/icons-material/EventNote';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useAuth } from '../context/AuthContext';
import AppShell from './AppShell';

const navItemsByRole = {
  superadmin: [
    { label: 'Overview', icon: <DashboardIcon />, path: '/admin' },
    { label: 'Grades & Classes', icon: <SchoolIcon />, path: '/admin/grades' },
    { label: 'Subjects (CAPS)', icon: <MenuBookIcon />, path: '/admin/subjects' },
    { label: 'Assign Educators', icon: <AssignmentIndIcon />, path: '/admin/assignments' },
    { label: 'Assessments & SBA', icon: <AssignmentTurnedInIcon />, path: '/admin/assessments' },
    { label: 'Recordings', icon: <VideoLibraryIcon />, path: '/admin/recordings' },
    { label: 'Users', icon: <PeopleIcon />, path: '/admin/users' },
    { label: 'Sessions', icon: <EventNoteIcon />, path: '/admin/sessions' },
    { label: 'Timetables', icon: <EventNoteIcon />, path: '/admin/timetables' },
    { label: 'Analytics', icon: <LeaderboardIcon />, path: '/admin/analytics' },
    { label: 'Support', icon: <SupportAgentIcon />, path: '/admin/support' },
  ],
  admin: [
    { label: 'Overview', icon: <DashboardIcon />, path: '/admin' },
    { label: 'Grades & Classes', icon: <SchoolIcon />, path: '/admin/grades' },
    { label: 'Subjects (CAPS)', icon: <MenuBookIcon />, path: '/admin/subjects' },
    { label: 'Assign Educators', icon: <AssignmentIndIcon />, path: '/admin/assignments' },
    { label: 'Assessments & SBA', icon: <AssignmentTurnedInIcon />, path: '/admin/assessments' },
    { label: 'Recordings', icon: <VideoLibraryIcon />, path: '/admin/recordings' },
    { label: 'Users', icon: <PeopleIcon />, path: '/admin/users' },
    { label: 'Sessions', icon: <EventNoteIcon />, path: '/admin/sessions' },
    { label: 'Timetables', icon: <EventNoteIcon />, path: '/admin/timetables' },
    { label: 'Analytics', icon: <LeaderboardIcon />, path: '/admin/analytics' },
    { label: 'Support', icon: <SupportAgentIcon />, path: '/admin/support' },
  ],
  educator: [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/educator' },
  ],
  student: [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/student' },
  ],
};

const DashboardLayout = ({ title, actions, children }) => {
  const { user, logout } = useAuth();

  const navItems = useMemo(() => navItemsByRole[user?.role] || [], [user?.role]);

  const handleLogout = () => {
    logout();
  };

  const topRight = (
    <Stack direction="row" spacing={1} alignItems="center">
      {actions}
      <Button
        color="primary"
        variant="outlined"
        startIcon={<LogoutIcon />}
        onClick={handleLogout}
      >
        Logout
      </Button>
    </Stack>
  );

  return (
    <AppShell
      brand="Homeschool"
      navItems={navItems}
      headerTitle={title || 'Dashboard'}
      topRight={topRight}
      userName={`${user?.name || ''} ${user?.surname || ''}`.trim()}
      userEmail={user?.email || ''}
      userRole={user?.role ? user.role.toUpperCase() : ''}
      collapseKey="adminSidebarCollapsed"
    >
      {children}
    </AppShell>
  );
};

export default DashboardLayout;
